
export default {
  name: 'ProductFeature',

  props: {
    type: {
      type: String,
      required: false,
      default: 'default',
    },
  },

  computed: {
    iconSrc() {
      // switch (this.featureType.toString().toLowerCase()) {
      //   case 'deductible':
      //     return require('~/assets/images/products/product-feature/tag-icons/deductible.svg');

      //   default:
      //     return require('~/assets/images/products/product-feature/tag-icons/deductible.svg');
      // }
      return require('~/assets/images/products/product-feature/tag-icons/' +
        this.type.toString().toLowerCase() +
        '.svg');
    },
  },
};
